import { useRef } from "react";
import Map, { GeolocateControl } from "react-map-gl";
import { Box } from "@chakra-ui/react";

import DrawControl from "./map/draw-control";
import ControlPanel from "./map/control-panel";

const MapSelector2 = ({ features, setFeatures }) => {
  const mapDraw = useRef(null);
  const featureIds = Object.keys(features);

  const onLoadDraw = (drawInstance) => {
    if (drawInstance) {
      mapDraw.current = drawInstance;
      Object.values(features).forEach((feature) => {
        drawInstance.add(feature);
      });
    }
  };

  let initialViewState = {
    longitude: 6.0,
    latitude: 59.0,
    zoom: 6,
  };
  if (featureIds.length > 0) {
    const firstFeature = features[featureIds[0]];
    console.log(
      "Initial view state",
      firstFeature.geometry.coordinates[0][0][0],
      firstFeature.geometry.coordinates[0][0][1]
    );
    if (firstFeature.geometry.type === "Polygon") {
      initialViewState = {
        longitude: firstFeature.geometry.coordinates[0][0][0],
        latitude: firstFeature.geometry.coordinates[0][0][1],
        zoom: 12,
      };
    }
  } else {
    console.log("No features");
  }

  const onCreate = (e) => {
    const feature = e?.features?.[0];
    if (!feature) return;
    setFeatures({ [feature.id]: feature });
  };

  const onUpdate = (e) => {
    const feature = e?.features?.[0];
    if (!feature) return;
    setFeatures({ [feature.id]: feature });
  };

  const onDelete = () => {
    setFeatures({});
  };

  const onModeChange = (e) => {
    // Clear the old polygon as soon as a new drawing starts
    if (e?.mode !== "draw_polygon" || !mapDraw.current || !featureIds.length) return;

    mapDraw.current.delete(featureIds);
    setFeatures({});
  };

  return (
    <Box width="100%" height={{ base: 400, md: 400, lg: 600 }}>
      <Map
        initialViewState={initialViewState}
        mapStyle="mapbox://styles/mapbox/satellite-v9"
        mapboxAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        style={{ width: "100%", height: "100%" }}
        mapLib={import("mapbox-gl")}
      >
        <DrawControl
          position="top-left"
          displayControlsDefault={true}
          controls={{
            polygon: true,
            line_string: false,
            point: false,
            trash: true,
          }}
          defaultMode={featureIds.length ? "simple_select" : "draw_polygon"}
          onLoad={onLoadDraw}
          onCreate={onCreate}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onModeChange={onModeChange}
        />
        <GeolocateControl
          positionOptions={{ enableHighAccuracy: true }}
          trackUserLocation={true}
          showUserLocation={true}
        />
      </Map>
      <ControlPanel polygons={Object.values(features)} />
    </Box>
  );
};

export default MapSelector2;
